import { render, staticRenderFns } from "./TextImage.vue?vue&type=template&id=8b1de8f4"
import script from "./TextImage.vue?vue&type=script&lang=ts"
export * from "./TextImage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports